(() => {
  if (window.WorthItProductFallback) return;
  window.WorthItProductFallback = true;
  const loaded = new WeakSet();
  const pending = new WeakSet();
  const nativeEdited = new WeakSet();

  async function enhance(product) {
    if (!product?.isConnected || !loaded.has(product) || pending.has(product)) return;
    const fallback = product.querySelector('[data-wi-native-product]');
    const formElement = product.querySelector('product-form[data-wi-enhanced-product]');
    if (!fallback || !formElement) return;
    pending.add(product);
    try {
      const picker = product.querySelector('variant-selects[data-wi-enhanced-product]');
      const quantity = product.querySelector('[data-wi-enhanced-product] quantity-input');
      const names = ['product-info', 'product-form'];
      if (picker) names.push('variant-selects');
      if (quantity) names.push('quantity-input');
      await Promise.all(names.map((name) => customElements.whenDefined(name)));
      if (!product.isConnected || !loaded.has(product)) return;
      if (!product.hasAttribute('data-wi-product-ready') &&
          (nativeEdited.has(product) || fallback.contains(document.activeElement))) return;
      const owns = (element, name) => element instanceof customElements.get(name);
      const form = formElement.querySelector('form');
      const submit = form?.querySelector('[type="submit"]');
      if (!owns(product, 'product-info') || !owns(formElement, 'product-form') ||
          formElement.form !== form || formElement.submitButton !== submit ||
          typeof formElement.hideErrors !== 'boolean' || typeof formElement.onSubmitHandler !== 'function' ||
          typeof product.onVariantChangeUnsubscriber !== 'function') return;
      if (picker && (!owns(picker, 'variant-selects') || product.variantSelectors !== picker)) return;
      if (quantity && (!owns(quantity, 'quantity-input') || quantity.input !== product.quantityInput ||
          typeof quantity.quantityUpdateUnsubscriber !== 'function')) return;
      const firstReady = !product.hasAttribute('data-wi-product-ready');
      fallback.querySelectorAll('input, select, button').forEach((control) => { control.disabled = true; });
      fallback.hidden = true;
      product.querySelectorAll('[data-wi-enhanced-product]').forEach((element) => { element.hidden = false; });
      product.setAttribute('data-wi-product-ready', '');
      if (firstReady) product.dispatchEvent(new CustomEvent('worth-it:product-ready', { bubbles: true }));
    } finally {
      pending.delete(product);
    }
  }

  document.addEventListener('product-info:loaded', (event) => {
    const product = event.target;
    if (!product?.matches?.('product-info')) return;
    loaded.add(product);
    enhance(product);
  });
  ['input', 'change'].forEach((type) => document.addEventListener(type, (event) => {
    const fallback = event.target.closest?.('[data-wi-native-product]');
    const product = fallback?.closest('product-info');
    if (product && !fallback.hidden) nativeEdited.add(product);
  }));
  document.addEventListener('focusout', (event) => {
    const product = event.target.closest?.('[data-wi-native-product]')?.closest('product-info');
    if (product) queueMicrotask(() => enhance(product));
  });
  // Native option updates replace the picker with freshly rendered hidden markup.
  // A connected replacement must own its real handler before it can be revealed.
  new MutationObserver((records) => {
    const products = new Set();
    records.forEach((record) => [...record.addedNodes].forEach((node) => {
      if (node.nodeType !== 1) return;
      const product = node.closest?.('product-info[data-wi-product-ready]');
      if (product && (node.matches('[data-wi-enhanced-product]') || node.querySelector('[data-wi-enhanced-product]'))) products.add(product);
    }));
    products.forEach(enhance);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
